import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-52">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-6 right-6 z-40 md:bottom-8 md:right-8 left-6 md:left-auto" data-id="element-53">
          <a href="#pricing" onClick={scrollToPricing} className="block w-full md:w-auto bg-truco-gold hover:bg-truco-goldHover text-truco-dark font-heading font-bold py-4 px-8 rounded-full shadow-[0_0_30px_rgba(212,168,83,0.3)] transition-all transform hover:scale-105 text-center text-sm md:text-base animate-pulse hover:animate-none" data-id="element-54">
            🃏 QUIERO MI BIBLIA DEL TRUCO →
          </a>
        </motion.div>}
    </AnimatePresence>;
}